import React from 'react'
import Page from '../components/containers/Page'
import { img_404bg } from '../assets'
import ImageMedia from '../components/common/ImageMedia'
import { useNavigate } from 'react-router-dom'
import Button from '../components/common/Button'
import useReportProblem from '../functions/reportProblem'

const X404 = () => {
  const navigate = useNavigate()
  const actions = [
    {
      label: 'Go back',
      variant: 'discreet',
      icon: 'ri-arrow-left-wide-line',
      action: () => {
        navigate(-1);
        // window.scrollY({ top: 0, behavior: 'instant' })
      }
    },
    {
      label: 'Report a problem',
      variant: 'action',
      action: useReportProblem('404')
    }
  ]
  return (
    <Page className='!max-h-screen overflow-y-hidden'>
      <ImageMedia
        src={img_404bg}
        title='bg404'
        className='h-[90vh] object-cover select-none muted lg:bottom-0 origin-top lg:left-0 pointer-events-none fixed max-sm:object-[-45vw] inset-x-0'
      />
      <div className='absolute noaction inset-x-0 flex bottom-[45%] origin-bottom translate-y-[-25%] lg:top-0 lg:translate-y-[] animate-slideup '>
        <h1 className='font-maison text-[58vw] text-center !mx-0 font-extrabold md:font-bold opacity-[.05]'>
          404
        </h1>
      </div>

      <div className='fixed inset-0 resp flex flex-col items-center justify-center'>
        <div className='flex flex-col h-full md:h-fit w-full items-end justify-between py-24 md:items-start'>
          <h1 className='capitalize translate-y-1/2= md:text-7xl max-sm:max-w-[8ch] leading- md:py-1 w-full inline text-right md:text-left h-fit font-bold= animate-slideright md:animate-slideup'>
            <span className='inline md:hidden'>—</span>
            <span className='inline w-full'>This page doesn&apos;t exist</span>
            {/* <span className='inline w-full'>This<br/>page<br/>doesn&apos;t<br/>exist</span> */}
            <span className='hidden md:inline'>—</span>
          </h1>

          <div className='flex items-center w-full mt-20 h-fit justify-start space-x-4'>
            {actions.map((item, i) => {
              return (
                <Button
                  key={item + i}
                  variant={item.variant}
                  onClick={item.action}
                  className='max-sm:flex-grow'
                >
                  {item.icon && <i className={`${item.icon} ri-lg`} />}
                  {item.label}
                </Button>
              )
            })}
          </div>
        </div>
      </div>
    </Page>
  )
}

export default X404
